import { useMemo } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { QUESTIONNAIRE_OVERVIEW_KEY, REQUEST_REVISION_KEY, TEMPLATE_RESULT_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

interface RequestRevisionData {
  crbId: string;
  templateResultId: string;
  note: string;
  dueDate: string;
}

export function useRequestRevision() {
  const { userBankId } = useUser();
  const questionnairesApi = useMemo(() => new QuestionnairesApi(), []);
  const queryClient = useQueryClient();

  const {
    mutateAsync: requestRevision,
    isPending: isRequestingRevision,
    error: requestRevisionError
  } = useMutation({
    mutationKey: [REQUEST_REVISION_KEY],
    mutationFn: (data: RequestRevisionData) =>
      questionnairesApi.requestRevision(userBankId, data.crbId, data.templateResultId, {
        note: data.note,
        due_date: data.dueDate
      }),
    onSuccess: () => {
      // Invalidates React Query caches; FI questionnaire detail pages still read from MobX
      // and refetch via `presenter.load` / `loadQuestionnaire` at the call site.
      queryClient.invalidateQueries({ queryKey: [QUESTIONNAIRE_OVERVIEW_KEY] });
      queryClient.invalidateQueries({ queryKey: [TEMPLATE_RESULT_KEY] });
    },
    meta: {
      snackbarSuccessMessage: 'Revision request sent.'
    }
  });

  return { requestRevision, isRequestingRevision, requestRevisionError };
}
